import { makeGuardedModal } from 'components/guardedModal/makeGuardedModal';
import { SimpleModalId } from 'constants/modalId';
import { ArchiveClientModalContentContainer } from './ArchiveClientModalContentContainer';

export const ArchiveClientModal = makeGuardedModal(SimpleModalId.ArchiveClient, ArchiveClientModalContentContainer);
